<template>
    <div class="object-info__inner accordion-body__inner request-table-inner request-table-inner--scroll
    request-table-inner--five-cells											js-entity-info-container js-copy-mobile-container">
        <!--
        <div class="js-entity-info-item request-table__scroll-container js-scroll-container js-row-hight-container">
            -->
        <div class="object-info__section object-info__section--short-top block"
             v-for="(product, index) in account.CalcData.Products">
            <div class="request-table">
                <div class="request-sub-table request-sub-table--not-border">
                    <div>
                        <div class="request-table__row request-table__row--entity js-row-account h5 js-row-hight">
                            <!--<div class="request-table__cell"></div>-->
                            <div class="request-table__cell request-table__cell--max request-table__cell--title ex-small">
                                {{product.ItemName}}
                            </div>

                            <div v-bind:class="['request-table__cell ', product.SaldoBegin<0 ? 'status-success' : '']">
                                <div class="request-table__label">К оплате <br>на {{account.CalcData.CalcDateStart}}, ₽</div>
                                {{product.SaldoBegin}}
                            </div>
                            <div class="request-table__cell request-table__cell--max">
                                <!--
                                <div class="request-table__label">Начисления текущего <br /> месяца (в т.ч. авансовые), ₽</div>
                                -->
                                <label class="cb-input" v-if="product.Accruals > 0.0">
                                    <input v-if="account.CalcData.CanPay" class="cb-input__checkbox js-account-check accruals-checkbox" v-bind:disabled="isEditSum || !product.ToPayCheck" type="checkbox" v-on:change="AccrualsClick(index)" v-model="product.AccrualsCheck">
                                    <!--
                                    <span v-if="account.CalcData.CanPay && !product.IsUserPay && !product.IsFine" class="cb-input__check"></span>
                                        -->
                                    <span v-if="account.CalcData.CanPay && !product.IsUserPay" class="cb-input__check"></span>
                                    <span class="cb-input__label cb-input__label--account" v-bind:style="{ color: (product.AccrualsCheck)?'Black':'Gray'}">{{product.Accruals}}</span>
                                </label>
                                <label class="cb-input" v-if="product.Accruals < 0.0">
                                    <span class="cb-input__label cb-input__label--account" v-bind:style="(product.AccrualsCheck<0) ? 'color: #2cb150' : 'color: black' ">{{product.Accruals}}</span>
                                </label>
                            </div>
                            <!--
                            <div class="request-table__cell request-table__cell--max">

                                <div class="request-table__label">Перерасчеты, ₽</div>

                                <table class="request-sm-table">
                                    <tr class="request-sm-table__row">
                                        <td class="request-sm-table__cell"><span v-if="product.Recalculation != 0.0" v-bind:style="(sumRecalculation<0) ? 'color: #2cb150' : 'color: black' ">{{product.Recalculation}}</span></td>
                                    </tr>
                                </table>
                            </div>
                            -->
                            <div class="request-table__cell request-table__cell--max">
                                <div class="request-table__label">Оплачено, ₽</div>
                                <table class="request-sm-table">
                                    <tr class="request-sm-table__row">
                                        <td class="request-sm-table__cell">{{product.Paid}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="request-table__cell">
                                <div class="request-table__label">К оплате <br> на {{account.CalcData.CalcDate}}, ₽</div>
                                <label class="cb-input" v-if="account.CalcData.CanPay && product.ToPayProd>0">
                                    <input class="cb-input__checkbox js-account-fix-check" v-bind:disabled="isEditSum" type="checkbox"
                                           v-model="product.ToPayCheck" v-on:change="ToPayClick()">
                                    <span class="cb-input__check"></span>
                                </label>
                                <span class="cb-input__label--account request-table__fix-sum-label" v-if="account.CalcData.CanPay && ((product.IsFine && product.SaldoEnd>0) || !product.IsFine)">
                                    <input @keydown="keydown($event)"
                                           @keyup="keyup($event)"
                                           v-if="product.SaldoEnd<0 && isShowSaldoEnd" class="txt-input__field txt-input__field--number input" v-bind:disabled="isEditSum" type="text"
                                           style="height: 25px; width: 70%; padding-left: 10px;" v-model="product.SaldoEnd" v-on:click="ChangeSaldoEnd(index)" v-bind:style="{ color: (product.SaldoEnd < 0.0)?'Green':'Black'}">
                                    <input @keydown="keydown($event)"
                                           @keyup="keyup($event)"
                                           v-else class="txt-input__field txt-input__field--number input" v-bind:disabled="isEditSum || !product.ToPayCheck" type="text"
                                           style="height: 25px; width: 70%; padding-left: 10px;" v-model="product.ToPayProd" v-on:click="SavePay(index)" v-on:change="UserPay(index)" v-bind:style="{ color: (product.ToPayCheck)?'Black':'Gray'}">
                                </span>
                                <span v-else class="cb-input__label--account request-table__fix-sum-label">
                                    <input @keydown="keydown($event)"
                                           @keyup="keyup($event)"
                                           class="txt-input__field txt-input__field--number input" disabled="disabled" type="text"
                                           style="height: 25px; width: 70%;" v-model="product.SaldoEnd" v-bind:style="{ color: (product.SaldoEnd<0)?'Green':'Black'}">
                                </span>
                                <span class="request-table__fix-sum-icon"></span>
                            </div>
                            <span v-if="payErr==index & typeErr==1" style="color: red">Ошибка формата «{{payText}}»</span>
                            <span v-if="payErr==index & typeErr==2 && product.SaldoEnd < 0" style="color: red">Пеня не может быть меньше «0»</span>
                            <span v-if="payErr==index & typeErr==2 && product.SaldoEnd > 0" style="color: red">Пеня не может быть больше «{{product.SaldoEnd}}»</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="object-info__section object-info__section--sm object-info__section--border block">
            <div class="request-table">
                <div class="request-table__cell"></div>
                <div class="request-table__row request-table__row--bg request-table__row--total h5">
                    <!--<div class="request-table__cell"></div>-->
                    <div class="request-table__cell request-table__cell--max">
                        Общая сумма
                    </div>
                    <div class="request-table__cell" v-bind:style="(sumDebtBeg<0) ? 'color: #2cb150' : 'color: black' ">
                        <div class="request-table__label">К оплате <br>на {{account.CalcData.CalcDateStart}}</div>
                        {{sumDebtBeg}} ₽
                    </div>
                    <div class="request-table__cell request-table__cell--max">
                        <div class="request-table__label">Начисления и Перерасчеты, ₽</div>
                        <span class="request-table__cell-check">{{sumAccruals}} ₽</span>
                    </div>

                    <!--
                    <div class="request-table__cell request-table__cell--max" v-bind:style="(sumRecalculation<0) ? 'color: #2cb150' : 'color: black' ">
                        <div class="request-table__label">Перерасчёты ₽</div>
                        {{sumRecalculation}} ₽
                    </div>
                    -->
                    <div class="request-table__cell request-table__cell--max">
                        <div class="request-table__label">stОплачено ₽</div>
                        <table class="request-sm-table">
                            <tr class="request-sm-table__row">
                                <td class="request-sm-table__cell">{{sumPaid}} ₽</td>
                            </tr>
                        </table>
                    </div>
                    <div class="request-table__cell">
                        <div class="request-table__label">К оплате <br> на {{account.CalcData.CalcDate}}, ₽</div>
                        <div v-if="account.CalcData.CanPay" class="request-table__cell-check text-edit-container js-text-edit-container">
                            <!--Поле редактирования суммы-->
                            <div v-if="isEditSum" class="line-form__amount-edit js-block-edit-payment-amount" style="width: 70%; display: block; border: 1px solid #0078a8; border-radius: 4px">
                                <input @keydown="keydown($event)"
                                       @keyup="keyup($event)"
                                       :id="idSsum" class="txt-input__field txt-input__field--number input" v-model="manSsum" data-mask-max-8="" type="text" :placeholder="ssum" style="height: 25px; width: 70%; padding-left: 10px; font-weight: bold; border: none;">
                                <button class="text-edit-trigger text-edit-trigger--remove js-clear-payment-amount" @click="CancelEdit" style="padding-left: 20px;"><i class="icon icon--close"></i></button>
                            </div>

                            <!--Поле вывода рассчитанной суммы-->
                            <span v-if="!isEditSum" class="js-button-payment-amount" style="display: block; width: 70%">
                                <span class="js-payment-amount-count-block" style="padding-left: 10px;">{{ssum}}</span> ₽
                            </span>

                            <!--Пиктограмма редактирования суммы-->
                            <i v-if="!isEditSum" class="icon icon--edit" style="margin-left: 30px;" @click="EditSsum"></i>
                            <!--<button v-if="!isEditSum" @click="EditSsum" class="text-edit-trigger text-edit-trigger--abs js-edit-payment-amount"><i class="icon icon--edit"></i></button>-->
                            <!--Пиктограмма пересчёта по алгоритму отредактированной суммы-->
                            <i v-if="isEditSum" class="icon icon--check" style="margin-left: 30px;" @click="recalcSsum"></i>
                            <!--<button v-if="isEditSum" @click="recalcSsum" class="text-edit-trigger text-edit-trigger--abs text-edit-trigger--remove js-check-edit-payment-amount"><i class="icon icon--check"></i></button>-->
                        </div>
                        <!--Просмотр предыдущих периодов-->
                        <div v-else class="request-table__cell-check text-edit-container js-text-edit-container">
                            <span class="js-button-payment-amount" style="display: block; width: 70%">
                                <span class="js-payment-amount-count-block" style="padding-left: 10px;">{{sumNotCanPay}}</span> ₽
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">

    const W13 = 12; // Отопление.
    const W99 = 3;  // Горячая вода.
    const W139 = 2; // ХВС.
    const W149 = 1; // Водоотведение.

    export default {
        name: 'account-products',

        props: {
            account: Object,
            cards: Array,
            updateTotal: null
        },
        data: function () {
            return {
                old: '',
                ssum: 0.0,
                payErr: -1,
                typeErr: 0,
                savePay: 0,
                payText: '',
                isEditSum: false,
                manSsum: 0.0,
                sumAllServices: 0.0,
                sumMainAddServices: 0.0,
                sumFineDuty: 0.0,
                sumWeightFactors: 0.0,
                isShowSaldoEnd: true
            }
        },
        computed: {
            CopySaldoEnd: function (index) {
                return this.account.CalcData.Products[index].SaldoEnd;
            },
            idSsum: function () {
                return 'idSsum' + this.account.PersonAccountId;
            },
            sumRecalculation: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {
                    sum += this.account.CalcData.Products[p].Recalculation;
                }
                return Math.round(sum * 100) / 100;
            },
            sumDebtBeg: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {

                    if (this.account.CalcData.Products[p].IsFine && this.account.CalcData.Products[p].SaldoBegin > 0) {
                        sum += this.account.CalcData.Products[p].SaldoBegin;
                    }
                    if (!this.account.CalcData.Products[p].IsFine) {
                        sum += this.account.CalcData.Products[p].SaldoBegin;
                    }
                }
                return Math.round(sum * 100) / 100;
            },
            sumPaid: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {
                    sum += this.account.CalcData.Products[p].Paid;
                }
                return Math.round(sum * 100) / 100;
            },
            sumAccruals: function () {
                var sum = 0.0;
                if (this.account.CalcData.CanPay) {

                    for (var p in this.account.CalcData.Products) {
                        if (this.account.CalcData.Products[p].AccrualsCheck) {
                            sum += this.account.CalcData.Products[p].Accruals;
                        }
                    }
                }
                else {
                    for (var p in this.account.CalcData.Products) {
                        sum += this.account.CalcData.Products[p].Accruals;
                    }
                }
                return Math.round(sum * 100) / 100;
            },
            sumNotCanPay: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {
                    sum += this.account.CalcData.Products[p].SaldoEnd;
                }
                return Math.round(sum * 100) / 100;
            }
        },
        methods: {
            keydown: function (event) {
                this.old = event.srcElement.value;
                let key = event.key;
                switch (key) {
                    case 'ArrowLeft':
                    case 'ArrowRight':
                    case 'Delete':
                    case 'Backspace':
                        break;
                    case '.':
                        if (this.old.indexOf('.') > -1) event.preventDefault();
                        break;
                    case 'Enter':
                        event.srcElement.blur();
                        break;
                    default:
                        if (/^[0-9]$/i.test(key)) {
                            var sum = this.old.split('.');
                            if (sum[0].length > 7 && this.old.indexOf('.') == -1) {
                                event.preventDefault();
                                return;
                            }
                            if (sum[0].length > 7 && sum[1].length > 1) event.preventDefault();
                        }
                        else
                            event.preventDefault();
                        break;
                }
            },
            keyup: function (event) {
                var sum = event.srcElement.value;
                var kop = '';
                var rub = '';
                rub = sum.split('.')[0];
                if (sum.indexOf('.') > -1)
                    kop = sum.split('.')[1];
                if (rub.length > 8 || kop.length > 2)
                    event.srcElement.value = this.old;
                return;
            },
            recalcSsum: function () {
                this.isEditSum = false;
                if (this.manSsum == '') this.manSsum = '0.00';
                if (typeof (this.manSsum) == "string") {
                    this.manSsum = this.manSsum.replace(',', '.');
                    this.manSsum = Number(this.manSsum);
                }
                if (isNaN(this.manSsum)) return;
                var lastIndex = -1;
                var difference = this.manSsum - this.sumAllServices
                if (difference !== 0.0) {
                    if (this.account.Status === 1) {
                        if (difference < 0) {
                            if (this.manSsum >= this.sumMainAddServices) {
                                difference = this.manSsum;
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //difference -= this.Debt(prod.SaldoEnd);
                                        difference -= this.Debt(se);
                                    }
                                }
                                if (difference > 0.0) {
                                    for (var index in this.account.CalcData.Products) {
                                        var prod = this.account.CalcData.Products[index];
                                        if (prod.IsFine || prod.Item.toString().substr(0, 1) == '8') {
                                            var se = prod.SaldoBegin
                                                //+ prod.Recalculation
                                                - prod.Paid;
                                            if (prod.AccrualsCheck) {
                                                se = se + prod.Accruals;
                                            }
                                            /*
                                            var sum = this.Debt(prod.SaldoEnd) / this.sumFineDuty * difference;
                                            if (sum > this.Debt(prod.SaldoEnd))
                                                sum = this.Debt(prod.SaldoEnd);
                                            */
                                            var sum = this.Debt(se) / this.sumFineDuty * difference;
                                            if (sum > this.Debt(se))
                                                sum = this.Debt(se);
                                            prod.ToPayProd = Math.round(sum * 100) / 100;
                                            if (se > 0) {
                                                lastIndex = index;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //var sum = this.Debt(prod.SaldoEnd) / this.sumMainAddServices * this.manSsum;
                                        var sum = this.Debt(se) / this.sumMainAddServices * this.manSsum;
                                        prod.ToPayProd = Math.round(sum * 100) / 100;
                                        if (se > 0) {
                                            lastIndex = index;
                                        }
                                    }
                                    else
                                        prod.ToPayProd = 0.0;
                                }
                            }
                        }
                    }
                    else {
                        if (difference < 0.0) {
                            if (this.manSsum >= this.sumMainAddServices) {
                                var diff = this.manSsum;
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //diff -= this.Debt(prod.SaldoEnd);
                                        diff -= this.Debt(se);
                                    }
                                }
                                if (diff > 0.0) {
                                    for (var index in this.account.CalcData.Products) {
                                        var prod = this.account.CalcData.Products[index];
                                        if (prod.IsFine || prod.Item.toString().substr(0, 1) == '8') {
                                            var se = prod.SaldoBegin
                                                // + prod.Recalculation
                                                - prod.Paid;
                                            if (prod.AccrualsCheck) {
                                                se = se + prod.Accruals;
                                            }
                                            /*
                                            var sum = this.Debt(prod.SaldoEnd) / this.sumFineDuty * diff;
                                            if (sum > this.Debt(prod.SaldoEnd)) {
                                                sum = this.Debt(prod.SaldoEnd);
                                            }
                                            */
                                            var sum = this.Debt(se) / this.sumFineDuty * diff;
                                            if (sum > this.Debt(se)) {
                                                sum = this.Debt(se);
                                            }
                                            prod.ToPayProd = Math.round(sum * 100) / 100;
                                            if (se > 0) {
                                                lastIndex = index;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //var sum = this.Debt(prod.SaldoEnd) / this.sumMainAddServices * this.manSsum;
                                        var sum = this.Debt(se) / this.sumMainAddServices * this.manSsum;
                                        prod.ToPayProd = Math.round(sum * 100) / 100;
                                        lastIndex = index;
                                    }
                                    else
                                        prod.ToPayProd = 0.0;
                                }
                            }
                        }
                        if (difference > 0.0 && this.sumWeightFactors != 0.0)
                            for (var index in this.account.CalcData.Products) {
                                var prod = this.account.CalcData.Products[index];
                                if (!prod.IsFine) {
                                    var se = prod.SaldoBegin
                                        // + prod.Recalculation
                                        - prod.Paid;
                                    if (prod.AccrualsCheck) {
                                        se = se + prod.Accruals;
                                    }
                                    var sum = 0.0;
                                    if (prod.Item == 13)
                                        sum = difference / this.sumWeightFactors * W13;
                                    if (prod.Item == 99)
                                        sum = difference / this.sumWeightFactors * W99;
                                    if (prod.Item == 139)
                                        sum = difference / this.sumWeightFactors * W139;
                                    if (prod.Item == 149)
                                        sum = difference / this.sumWeightFactors * W149;
                                    //prod.ToPayProd = Math.round((sum + this.Debt(prod.SaldoEnd)) * 100) / 100;
                                    prod.ToPayProd = Math.round((sum + this.Debt(se)) * 100) / 100;
                                    if (se > 0) {
                                        lastIndex = index;
                                    }
                                }
                            }
                    }

                    var sumProds = this.account.CalcData.Products.reduce(function (p, c) { return p + c.ToPayProd; }, 0);
                    if (sumProds != this.manSsum) {
                        var delta = sumProds - this.manSsum;
                        if (lastIndex >= 0) {
                            this.account.CalcData.Products[lastIndex].ToPayProd =
                                Math.round(
                                    (this.account.CalcData.Products[lastIndex].ToPayProd - Math.round((Math.round(delta * 1000) / 1000) * 100) / 100)
                                    * 100) / 100;

                        }
                    }

                    this.calcSum();
                }
            },
            EditSsum: function () {
                this.isShowSaldoEnd = false;
                this.isEditSum = true;
                for (var index in this.account.CalcData.Products)
                    if (this.account.CalcData.Products[index].SaldoEnd > 0.0) {
                        this.account.CalcData.Products[index].ToPayCheck = true;
                        //this.account.CalcData.Products[index].AccrualsCheck = true;
                        this.account.CalcData.Products[index].IsUserPay = false;
                        this.account.CalcData.Products[index].ToPayProd = this.account.CalcData.Products[index].SaldoEnd;
                    }
                    else
                        this.account.CalcData.Products[index].ToPayProd = 0.0;
                this.calcSum();
                this.manSsum = this.ssum;
                var self = this;
                window.setTimeout(function () {
                    document.getElementById(self.idSsum).focus();
                }, 300);
            },
            calcRowsSaldoEnd: function () {
                for (var p in this.account.CalcData.Products) {
                    var sumrow = this.account.CalcData.Products[p].SaldoBegin
                        // + this.account.CalcData.Products[p].Recalculation
                        - this.account.CalcData.Products[p].Paid;
                    if (this.account.CalcData.Products[p].AccrualsCheck) {
                        sumrow += this.account.CalcData.Products[p].Accruals;
                    }
                    sumrow = Math.round((Math.round(sumrow * 1000) / 1000) * 100) / 100;
                    this.account.CalcData.Products[p].SaldoEnd = sumrow;
                    this.account.CalcData.Products[p].ToPayProd = sumrow;
                }
            },
            calcSum: function () {
                var sum = 0.0;
                if (this.account.CalcData.CanPay) {
                    for (var p in this.account.CalcData.Products) {
                        if (this.account.CalcData.Products[p].ToPayCheck) {
                            if (Number(this.account.CalcData.Products[p].ToPayProd) > 0) {
                                sum += Number(this.account.CalcData.Products[p].ToPayProd);
                            }
                        }
                    }
                }
                else {
                    for (var p in this.account.CalcData.Products) {
                        sum += this.account.CalcData.Products[p].SaldoEnd;
                    }
                }
                this.ssum = Math.round(sum * 100) / 100;
            },
            SavePay: function (index) {
                this.savePay = this.account.CalcData.Products[index].ToPayProd;
            },
            ChangeSaldoEnd: function (index) {
                this.isShowSaldoEnd = false;
            },
            UserPay: function (index) {
                this.isShowSaldoEnd = false;
                var pay = this.account.CalcData.Products[index].ToPayProd;
                if (pay == '') pay = '0.00';
                this.payText = pay;
                pay = pay.toString().replace(',', '.');
                pay = Number(pay);
                if (isNaN(pay)) {
                    this.payErr = index;
                    this.typeErr = 1;
                    this.account.CalcData.Products[index].ToPayProd = this.savePay;
                }
                else {
                    var isFine = this.account.CalcData.Products[index].IsFine;
                    if ((pay < 0 || pay > this.account.CalcData.Products[index].SaldoEnd) && isFine) {
                        this.account.CalcData.Products[index].ToPayProd = this.account.CalcData.Products[index].SaldoEnd;
                        this.payErr = index;
                        this.typeErr = 2;
                    }
                    else {
                        this.payErr = -1;
                        this.typeErr = 0;
                        this.account.CalcData.Products[index].ToPayProd = Math.round(pay * 100) / 100;
                        this.account.CalcData.Products[index].IsUserPay = true;
                        this.calcSum();
                    }
                }
            },
            AccrualsClick: function (index) {
                /*
                var prod = this.account.CalcData.Products[index];
                var sum = prod.SaldoEnd;
                if (prod.AccrualsCheck)
                    sum = sum + prod.Accruals;
                if (sum < 0) sum = 0;
                else
                    sum = Math.round(sum * 100) / 100
                prod.ToPayProd = sum;*/
                this.calcRowsSaldoEnd();
                this.calcSum();
            },
            ToPayClick: function () {
                this.calcRowsSaldoEnd();
                this.calcSum();
                return;
            },
            Debt: function (saldo) {
                saldo = Number(saldo);
                return (saldo > 0.0) ? saldo : 0.0;
            },
            CancelEdit: function () {
                this.isEditSum = false;
                this.isShowSaldoEnd = true;

                /*
                for (var index in this.account.CalcData.Products) {
                    var prod = this.account.CalcData.Products[index];
                    //prod.AccrualsCheck = false;
                    prod.ToPayCheck = true;
                    prod.IsUserPay = false;
                    prod.ToPayProd = Math.round((prod.SaldoEnd) * 100) / 100;
                    if (prod.ToPayProd < 0.0) prod.ToPayProd = 0.0;
                }
                */

                this.calcRowsSaldoEnd();
                this.calcSum();
            }
        },
        watch: {
            ssum: function (newSum) {
                this.$emit('updateSum');
            },
            isShowSaldoEnd: function (newVal) {
                this.$emit('updateTitle', newVal || !this.account.CalcData.CanPay);
            }
        },
        mounted() {
            this.calcRowsSaldoEnd();
            this.calcSum();
            this.sumAllServices = 0.0;  // Общая сумма начислений по счёту.
            this.sumMainAddServices = 0.0; // Сумма начислений по ОУ и ДУ.
            this.sumFineDuty = 0.0;     // Пеня и госпошлина.
            this.sumWeightFactors = 0.0; // Сумма весовых коэффициентов.
            let rowsum = 0.0; // сумма по строке
            for (var index in this.account.CalcData.Products) {
                rowsum = this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                this.sumAllServices += rowsum;
                if (this.account.CalcData.Products[index].IsFine || this.account.CalcData.Products[index].Item.toString().substr(0, 1) == '8')
                    this.sumFineDuty += this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                else
                    this.sumMainAddServices += this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                if (this.account.CalcData.Products[index].Item == 13)
                    this.sumWeightFactors += W13;
                if (this.account.CalcData.Products[index].Item == 99)
                    this.sumWeightFactors += W99;
                if (this.account.CalcData.Products[index].Item == 139)
                    this.sumWeightFactors += W139;
                if (this.account.CalcData.Products[index].Item == 149)
                    this.sumWeightFactors += W149;
            }
            this.isShowSaldoEnd = true;
            //for (var index in this.account)
            //    this.account.Status = 1;

        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-products.vue